// Company user permissions - mirrors Backend/utils/permissions.js.
//
// Founders and Super Users have full access. Restricted ("user") accounts only
// see the sections checked for them on the company's user management page.

export const PERMISSION_GROUPS = [
  {
    title: 'Main Sections',
    permissions: [
      { key: 'grants', label: 'Grant & Fund Management' },
      { key: 'legal_documents', label: 'Legal Documents' },
      { key: 'cap_table', label: 'Cap Table' },
      { key: 'personnel', label: 'Personnel' },
      { key: 'board_minutes', label: 'Board Meeting Minutes' },
      { key: 'data_room', label: 'Data Room & Investor Portal' },
      { key: 'company_info', label: 'Company Info' },
      { key: 'registrations', label: 'Registrations' }
    ]
  },
  {
    title: 'Company Details',
    permissions: [
      { key: 'ein', label: 'EIN' },
      { key: 'bank_info', label: 'Bank Info' }
    ]
  }
];

export const ALL_PERMISSIONS = PERMISSION_GROUPS.flatMap(g => g.permissions);
export const PERMISSION_KEYS = ALL_PERMISSIONS.map(p => p.key);

export const permissionLabel = (key) =>
  ALL_PERMISSIONS.find(p => p.key === key)?.label || key;

// Roles that always have every permission.
const FULL_ACCESS_ROLES = ['founder', 'super_user', 'super_client'];
const FULL_ACCESS_ACCOUNT_TYPES = ['admin', 'superadmin'];

export const roleLabel = (role) =>
  role === 'super_user' || role === 'super_client' ? 'Super User'
    : role === 'founder' ? 'Founder'
    : 'User';

export const isFullAccessRole = (role, accountType) =>
  FULL_ACCESS_ROLES.includes(role) || FULL_ACCESS_ACCOUNT_TYPES.includes(accountType);

// Does this logged-in user have access to a given section?
export const hasPermission = (userInfo, key) => {
  if (!userInfo) return false;
  if (isFullAccessRole(userInfo.companyRole, userInfo.accountType)) return true;
  if (userInfo.isSuperUser) return true;
  // Sessions created before permissions existed have no list - don't lock them out.
  if (!Array.isArray(userInfo.permissions)) return true;
  return userInfo.permissions.includes(key);
};

// Hierarchy: Founders manage everyone, Super Users manage everyone but
// Founders, restricted users manage nobody.
export const canManageUserRole = (actorRole, targetRole, actorAccountType) => {
  if (FULL_ACCESS_ACCOUNT_TYPES.includes(actorAccountType)) return true;
  if (actorRole === 'founder') return true;
  if (actorRole === 'super_user' || actorRole === 'super_client') return targetRole !== 'founder';
  return false;
};

// Roles the current user is allowed to assign to someone else.
export const assignableRoles = (actorRole, actorAccountType) => {
  if (FULL_ACCESS_ACCOUNT_TYPES.includes(actorAccountType) || actorRole === 'founder') {
    return ['user', 'super_user', 'founder'];
  }
  if (actorRole === 'super_user' || actorRole === 'super_client') return ['user', 'super_user'];
  return [];
};
